var MESSAGE_TYPE_MENU_MAIN_UPDATE = 'menuMainUpdate';
var MESSAGE_TYPE_MESSENGER = 'messenger';
var MESSAGE_TYPE_MESSENGER_READ = 'messengerRead';
var MESSAGE_TYPE_MESSENGER_READ_MESSAGE = 'messengerReadMessage';
var MESSAGE_TYPE_DEAL_STATUS_CHANGE = 'dealStatusChange';
var MESSAGE_TYPE_CREATE_DEALS = 'createDeals';
var MESSAGE_TYPE_PROJECT_CREATE = 'projectCreate';
var MESSAGE_TYPE_PROJECT_DELETE = 'projectDelete';
var MESSAGE_TYPE_DATA_LAYER = 'dataLayer';
var MESSAGE_TYPE_REDIRECT = 'redirect';
var MESSAGE_TYPE_CATALOG_EXPORT_FINISH = 'catalogExportFinish';
var MESSAGE_INVOICE_NOTIFY = 'invoiceNotify';
export { MESSAGE_TYPE_MENU_MAIN_UPDATE, MESSAGE_TYPE_MESSENGER, MESSAGE_TYPE_MESSENGER_READ, MESSAGE_TYPE_MESSENGER_READ_MESSAGE, MESSAGE_TYPE_DEAL_STATUS_CHANGE, MESSAGE_TYPE_CREATE_DEALS, MESSAGE_TYPE_PROJECT_CREATE, MESSAGE_TYPE_PROJECT_DELETE, MESSAGE_TYPE_DATA_LAYER, MESSAGE_TYPE_REDIRECT, MESSAGE_TYPE_CATALOG_EXPORT_FINISH, MESSAGE_INVOICE_NOTIFY };